import Img from "@casino/legacy/client/shared/images/Img";
import SocialButtonElement from "./SocialButtonElement";
import useSocialButton from "./useSocialButton";

type Props = {
  providerId: Connection;
  onClick?: () => void;
  mainButton?: boolean;
};

const SocialButton: FC<Props> = ({ onClick, providerId, mainButton }) => {
  const { title, src } = useSocialButton({ providerId });
  if (!title) {
    return null;
  }

  return (
    <SocialButtonElement onClick={onClick} $mainButton={mainButton}>
      <Img src={src} alt={providerId} />
      <span>{title}</span>
    </SocialButtonElement>
  );
};

export default SocialButton;
